import contract, {selectors} from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'

const init = (elem) => {
  console.log('send page', elem)
}

export default contract({
  [selectors]: {
    ':scope': array([
      init
    ])
  }
})
